import { getNewNotifications, getNewNotificationsCount } from './actions/eventsApi';
import { setDashboardNeedsRefresh } from './actions/dashboardActions';
import { Auth } from 'aws-amplify';
import { showNewNotificationToast } from './notificationMiddleware.helpers';
import {
    getOpenKnotsToastFromNotificationRecord,
    hasRecentOpenKnotsLifecycleToast,
} from '../realtime/openKnotsBidLifecycle';
import { showOpenKnotsLifecycleToast } from '../realtime/openKnotsToast';

let notificationInProgress = false;
let pollInterval = null;

const notificationMiddleware = (store) => (next) => async (action) => {
    const result = next(action);

    // WebSocket handlers also refresh notifications. Keep the 30s poll so a missed event still surfaces.
    const isLoggedIn = localStorage.getItem('isLoggedIn') === '1';
    const accessToken = localStorage.getItem('accessToken');
    const selectedBuyer = localStorage.getItem('associatedBroker');
    if (!isLoggedIn || !accessToken) {
        return result;
    }

    const platform_role = localStorage.getItem('platform_role');
    const userUlId =
        platform_role === 'broker' ? localStorage.getItem('brokerUlid') : localStorage.getItem('loggedUserUlid');

    if (
        userUlId &&
        !notificationInProgress &&
        action.type !== 'events/updatePrevPageNotification' &&
        action.type !== 'events/updateNextPrevPage' &&
        action.type !== 'getAllPorts/pending' &&
        action.type !== 'getAllPorts/fulfilled'
    ) {
        notificationInProgress = true;

        const fetchNotifications = async () => {
            try {
                const queryWithCat = {
                    buyerOrganizationULID:
                        localStorage.getItem('associatedBroker') === '' ? null : localStorage.getItem('associatedBroker'),
                    organizationULID: userUlId,
                    limit: 3,
                    cursor: 0,
                };

                const { app } = store.getState();
                let countState;
                const queryForNewCount = {
                    organizationULID: userUlId,
                    timeStamp: app.events.newNotificationList[0]?.created_at,
                };
                await Auth.currentAuthenticatedUser();
                const notifResult = await store.dispatch(getNewNotifications(queryWithCat));
                if (app.events.newNotificationList[0]?.created_at) {
                    countState = await store.dispatch(getNewNotificationsCount(queryForNewCount));
                }
                const { meta, payload } = countState || {};
                const notifications = notifResult?.payload?.notifications || [];
                if (meta && meta.requestStatus === 'fulfilled' && payload !== 0) {
                    const rowToast = getOpenKnotsToastFromNotificationRecord(notifications[0]);
                    if (rowToast) {
                        if (!hasRecentOpenKnotsLifecycleToast(rowToast.dedupeKey)) {
                            showOpenKnotsLifecycleToast(rowToast);
                        }
                    } else {
                        showNewNotificationToast(payload, selectedBuyer);
                    }
                }
                const newDealFinancing = notifications.find(
                    (n) => n.payload && n.payload.event === 'Deal Financing'
                );
                if (newDealFinancing) {
                    store.dispatch(setDashboardNeedsRefresh(true));
                }
            } catch (error) {
                // ignore
            }
        };

        await fetchNotifications();

        if (!pollInterval) {
            pollInterval = setInterval(fetchNotifications, 30000);
        }
    }

    return result;
};

export default notificationMiddleware;
